import { mapMutations } from 'vuex'
import Auth from '@/modules/auth/models/Auth'
import Parent from '@/modules/parent/models/Parent'
import Individual from '@/modules/individual/models/Individual'

export default {
  methods: {
    ...mapMutations('snackbar', ['showSnackbar', 'showErrorSnackbar']),
    async switchAccount(from, to) {
      if (
        !(
          (from.type === 'parent' && to.type === 'individual') ||
          (from.type === 'individual' && to.type === 'individual') ||
          (from.type === 'individual' && to.type === 'parent')
        )
      ) {
        console.error('Wrong user type to switch account', from, to)
        return
      }
      this.showSnackbar(`Redirecting to  ${to.first_name}'s dashboard`)
      if (from.type === 'parent') {
        await Parent.dispatch('switchToChild', to.id)
        // await Auth.dispatch('logout', 'parents')
      } else if (from.type === 'individual') {
        if (to.type === 'individual') {
          Auth.delete(from.id)
          await Individual.dispatch('switchToSibling', to.id)
        } else if (to.type === 'parent')
          await Auth.dispatch('logout', 'individuals')
      }
      if (to.type === 'parent') {
        this.$router.push('/parent/dashboard/overview')
      } else if (to.type === 'individual') {
        await Auth.dispatch('me', 'individuals')
        this.$router.push('/user/dashboard/overview').catch(_error => {
          console.log('did not have to switch dashboard')
        })
      }
    }
  }
}
